import { render } from "./Header.vue?vue&type=template&id=36e4aa02&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=36e4aa02&scoped=true&lang=css"
import "./Header.vue?vue&type=style&index=1&id=36e4aa02&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e4aa02"]])

export default __exports__